import React from "react";
import InputTextComp from "@components/UI/InputText/Index";
import EtapaProcesso from "@components/UI/EtapaProcesso/Index";
import { tipoComplianceOptions } from "@enums/Compliance/Index";
import { flagAuditoriaOptions } from "@enums/FlagAuditoria/Index";

function Associacao({ complianceFields, etapaProcesso, loading, error }) {

    if (loading) {
        return <p>Carregando dados do compliance...</p>;
    }
    if (error) {
        return <p>Ocorreu um erro: {error.message}</p>;
    }
    if (!complianceFields) {
        return <p>Nenhum dado de compliance encontrado.</p>;
    }

    const {
        tipoCompliance,
        ano,
        codigo,
        tipoServico,
        flagAuditoria,
        tipoServicoAssociado,
        nomeProcesso,
    } = complianceFields;


    const labelCompliance = tipoComplianceOptions.find(opt => opt.value === tipoCompliance)?.label || '-';

    const labelFlagAuditoria = flagAuditoriaOptions.find(opt => opt.value === flagAuditoria)?.label || '-';

    return (
        <div className="form">
            <div className="col-md-12">
                <div className="row mt-3">

                    {/* Coluna Esquerda */}
                    <div className="col-4 col-md-4 p-0">
                        <InputTextComp
                            label="Compliance"
                            value={labelCompliance}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Ano"
                            value={ano}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Código"
                            value={codigo}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="É uma Auditoria?"
                            value={labelFlagAuditoria}
                            placeholder="-"
                            required
                            disabled
                        />

                    </div>

                    {/* Coluna Direita */}
                    <div className="col-8 col-md-8 p-0">

                        <InputTextComp
                            label="Serviço"
                            value={tipoServico}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Tipo"
                            value={tipoServicoAssociado}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Processo"
                            value={nomeProcesso}
                            placeholder="-"
                            required
                            disabled
                        />

                        <InputTextComp
                            label="Etapa do Processo"
                            value={EtapaProcesso(etapaProcesso)}
                            placeholder="-"
                            required
                            disabled
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Associacao;
